import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-quiz-timer',
  templateUrl: './quiz-timer.component.html',
  styleUrls: ['./quiz-timer.component.scss']
})
export class QuizTimerComponent {
  @Input() value: number = 30;
  @Input() max: number = 30;
  @Input() currLang: any = 'en';

  get percentage(): number {
    return (this.value / this.max) * 100;
  }

  get circumference(): number {
    return 2 * Math.PI * 36; // radius = 36
  }

  get dashOffset(): number {
    return this.circumference * (1 - this.percentage / 100);
  }

  get timerColor(): string {
    if (this.percentage > 60) return '#4CAF50';
    if (this.percentage > 30) return '#FF9800';
    return '#F44336';
  }
}
